<template>
  <div>
    <menu-superior :link="'/'+ this.$store.state.empresa_url + '/menu'" titulo="DETALHES DO PRODUTO">
      <a class="right" @click="compartilhar">
        <i class="material-icons" :style="'font-size: 27px; color: #fff'">share</i>
      </a> &nbsp;&nbsp;
    </menu-superior>
    <div>
      <span class="notify-badge-slides" v-if="this.$store.state.produto.galerias.length > 0"><i
        class="far fa-images"></i></span>
      <div v-if="!imagens.length > 0" align="center">
        <img v-if="this.$store.state.produto.foto" :src="this.$store.state.produto.produto_imagem" id="imagemdestaque"
             :alt="this.$store.state.produto.nome" class="banner materialboxed responsive-img fotounica">
        <img v-else src="../../assets/no-image-1.jpg" class="banner materialboxed responsive-img fotounica"/>
      </div>
      <Carousel v-else :capa="this.$store.state.produto.produto_imagem"></Carousel>
    </div>
    <div class="container" style="padding-top: 5px">
      <div class="itemb">
        <h2 class="titulo-item" style="margin-bottom: 0px; line-height: 1;margin-top: 10px">
          {{ this.$store.state.produto.nome.toLocaleUpperCase() }}</h2>
      </div>

      <div class="itemb">
        <span style="padding-top: 1px;"
              v-if="$store.state.produto.controlar_estoque == 'S'">
          <i class="fa fa-cube"></i> {{ $store.state.produto.quantidade }} Disponíveis
        </span>
      </div>

      <div class="">
        <p v-if="this.$store.state.produto.descricao" class="titulo-descricao" style="    margin-bottom: 5px;"
           v-html="this.$store.state.produto.descricao">
        </p>
      </div>

      <div class="">
        <div class="titulo-valor" style="    margin-bottom: 2px;">
        <span class="price-new">
          <strong style="font-size: medium"
                  v-if="this.$store.state.produto.promocao == 'S'">R${{ this.$store.state.produto.valor_promocional }}</strong>
          <strike style="font-size: small"
                  v-if="this.$store.state.produto.promocao == 'S'">R${{ this.$store.state.produto.valor }}</strike>
          <strong style="font-size: medium"
                  v-if="this.$store.state.produto.promocao == 'N'">R${{ this.$store.state.produto.valor }}</strong>
        </span>
        </div>
      </div>

    </div>

    <br>

    <div v-if="this.$store.state.produto.categorias.length > 0">

      <div v-for="categorias in this.$store.state.produto.categorias" class=""
           style="padding-left: 6px;padding-right: 3px">
        <span v-if="categorias != null">
          <titulo-destacado :titulo="categorias.nome">
            <p>{{ categorias.descricao }}
              <strong v-if="categorias.limitar == 'S'"
                      style='font-size: small; color: #1d7d74;'>Minimo: {{
                  categorias.minimo
                }}, Máximo: {{ categorias.maximo }}</strong>
              <strong v-if="categorias.obrigatorio == 'S'" style='font-size: small; color: red;'>* Obrigatório</strong>
            </p>
          </titulo-destacado>

          <table>
            <tbody>
            <tr v-for="itemAdicional in categorias.itens">
              <td v-if="itemAdicional.adicional" class="" width="70%">

                <div class="row" style="margin: 0px">
                  <div v-if="itemAdicional.adicional.foto" class="col s3" style="padding: 0px;"
                       @click="selecionarImagem(itemAdicional.adicional.adicional_imagem)">
                    <a class="modal-trigger" href="#modal1">
                      <img class="" data-caption="" width="100%"
                           :src="itemAdicional.adicional.adicional_imagem">
                    </a>
                  </div>
                  <div class="col s9">
                    {{ itemAdicional.adicional.nome }}
                    <br>
                    <span style="width: 110px;">
                      <span
                        v-if="((itemAdicional.valor_adicional != null ? itemAdicional.valor_adicional : itemAdicional.adicional.valor) != '0.00')">
                        <span style="padding-right: 5px;font-size: 17px">
                          +
                        </span>
                        <span style="font-size: 12px; font-weight: 600">
                          R$ {{
                            (itemAdicional.valor_adicional != null ? itemAdicional.valor_adicional : itemAdicional.adicional.valor)
                          }}
                        </span>
                      </span>
                      <br>
                      <span style="padding-top: 5px;font-weight: bold; font-size: small"
                            v-if="itemAdicional.adicional.controlar_estoque == 'S'">
                        <i
                          class="fa fa-cube"></i> {{
                          categoriaAdicionalQtdOriginal[itemAdicional.adicional.id] ? categoriaAdicionalQtdOriginal[itemAdicional.adicional.id] : itemAdicional.adicional.quantidade
                        }} Disponíveis
                      </span>
                    </span>
                    <span v-if="itemAdicional.adicional.descricao" style="color: lightslategrey;font-size: small">
                      <hr/>
                      {{ itemAdicional.adicional.descricao }}
                    </span>

                  </div>
                </div>

              </td>

              <td v-if="itemAdicional.adicional" class="right">
                <a v-if="categoriaAdicionalQtd[itemAdicional.id]"
                   class="waves-effect waves-light btn-small teal lighten-3"
                   @click="removerItemDeCategorias(itemAdicional)" style="padding-left: 5px;padding-right: 5px">
                  <span style="font-weight: 700"><i class="material-icons" style="font-size: 17px">remove</i></span>
                </a>
                <a v-if="categoriaAdicionalQtd[itemAdicional.id] && categoriaAdicionalQtd[itemAdicional.id] > 0"
                   class="btn-flat disabled btn-small" style="padding-left: 7px;padding-right: 7px">
                  <span style="font-weight: 700">{{ categoriaAdicionalQtd[itemAdicional.id] || '' }} </span>
                </a>
                <a class="waves-effect waves-light btn-small teal lighten-3"
                   style="padding-left: 5px;padding-right: 5px"
                   @click="adicionarItemDeCategorias(itemAdicional,categorias)">
                  <span style="font-weight: 700"><i class="material-icons" style="font-size: 17px">add</i></span>
                </a>
              </td>

            </tr>
            </tbody>
          </table>

        </span>
      </div>

    </div>

    <bloco
      v-if="this.$store.state.produto.adicionais.length > 0 && this.$store.state.produto.categorias.length == 0 && adicional_ativo">
      <titulo-destacado titulo="Adicionais"></titulo-destacado>
      <table>
        <tbody>
        <tr v-for="adicionais in this.$store.state.produto.adicionais">
          <td v-if="adicionais.adicional" class="" width="70%">

            <div class="row" style="margin: 0px">
              <div v-if="adicionais.adicional.foto" class="col s3" style="padding: 0px;"
                   @click="selecionarImagem(adicionais.adicional.foto)">
                <a class="modal-trigger" href="#modal1">
                  <img class="" data-caption="" width="100%"
                       :src="this.$store.state.url_files + 'adicionais/' + adicionais.adicional.foto">
                </a>
              </div>
              <div class="col s9">
                {{ adicionais.adicional.nome }}
                <br>
                <span
                  v-if="((adicionais.valor_adicional != null ? adicionais.valor_adicional : adicionais.adicional.valor) != '0.00')">
                      <span style="padding-right: 5px;font-size: 17px">
                        +
                      </span>
                      <span style="font-size: 12px; font-weight: 600">
                        R$ {{
                          (adicionais.valor_adicional != null ? adicionais.valor_adicional : adicionais.adicional.valor)
                        }}
                      </span>
                    </span>
                <br>
                <span style="padding-top: 5px;font-weight: bold; font-size: small"
                      v-if="adicionais.adicional.controlar_estoque == 'S'">
                      <i class="fa fa-cube"></i> {{ adicionais.adicional.quantidade }} Disponíveis
                    </span>
              </div>
            </div>
          </td>

          <td v-if="adicionais.adicional" class="right">
            <p class="checkbox-customizado right">
              <label>
                <input type="checkbox" v-model="item.adicionais" :value="adicionais.adicional"
                       :id="adicionais.adicional.id" @click="check($event,adicionais.adicional)" class="filled-in"/>
                <span v-if="adicionais.adicional.foto"></span>
                <span v-else>R$ {{ adicionais.adicional.valor }}<span
                  style="padding-right: 5px;font-size: 17px">+</span></span>
              </label>
            </p>
          </td>

        </tr>
        </tbody>
      </table>

    </bloco>

    <bloco>
      <titulo-destacado titulo="Alguma observação?"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria "></titulo-destacado>
      <div class="input-field col s12">
        <textarea v-model="item.observacao_cliente" placeholder="Digite aqui sua observação" id="observacao"
                  class="materialize-textarea" data-length="150"></textarea>
      </div>
      <br>
      <br>
      <br>
      <br>
      <br>
    </bloco>

    <!-- Modal Structure -->
    <div id="modal1" class="modal">
      <span class="modal-close waves-effect waves-green btn-flat btn-fechar">Fechar </span>
      <div class="modal-content">
        <img class="materialboxed" data-caption="" width="100%" :src="this.$store.state.imagem_zoom">
      </div>
    </div>


    <!--    fechado-->
    <caixa-flutuante-inferior altura="120" v-if="this.$store.state.empresa.aberto == 'N'" style="background-color: #e51c23;">
      <span style="width: 100%;">
        <h6 class="center-align" style="font-weight: 500; margin: 3px">Loja Fechada!</h6>
        <p class="center-align" style="padding: 3px; margin: 5px; font-size: 13px">
          No momento, não estamos aceitando novos pedidos.
        </p>
        <a class="waves-effect waves-light btn-small disabled btn-large" style="width: 100%">Adicionar</a>
      </span>
    </caixa-flutuante-inferior>

    <!--    aberto-->
    <caixa-flutuante-inferior altura="70" v-if="this.$store.state.empresa.aberto == 'S'"
                              style="background-color: white;">
      <div class="col">
        <p class="left">
          <a @click="atualizarQuantidade(false)" class="waves-effect waves-light btn-small"
             :style="'padding-left: 5px;padding-right: 5px;background-color:'+this.$store.state.empresa.cor_primaria">
            <span style="font-weight: 700">
              <i class="material-icons" style="font-size: 17px">remove</i>
            </span>
          </a>
          <a class="btn-flat disabled btn-small" :style="'padding-left: 7px;padding-right: 7px;'">
            <span :style="'font-weight: 700;color:'+this.$store.state.empresa.cor_primaria">{{ formatQtde() }}</span>
          </a>
          <a @click="atualizarQuantidade(true)" class="waves-effect waves-light btn-small"
             :style="'padding-left: 5px;padding-right: 5px;background-color:'+this.$store.state.empresa.cor_primaria">
            <span style="font-weight: 700">
              <i class="material-icons" style="font-size: 17px">add</i>
            </span>
          </a>
        </p>
      </div>
      <div class="col">
        <p class="checkbox-customizado right">
          <a v-if="verificarCategorias()" @click="adicionarPedido()" class="waves-effect waves-light btn-small"
             :style="'background-color:'+this.$store.state.empresa.cor_primaria">Adicionar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-weight: 700">R$ {{ (total_itens_adicionais * item.quantidade).toFixed(2) }}</span></a>
          <a v-if="!verificarCategorias()" class="btn-small teal disabled">Adicionar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            style="font-weight: 700">R$ {{ (total_itens_adicionais * item.quantidade).toFixed(2) }}</span></a>
        </p>
      </div>
    </caixa-flutuante-inferior>
  </div>
</template>

<script>
import TituloDestacado from "../Widgets/TituloDestacado";
import Bloco from "../Widgets/Bloco";
import MenuSuperior from "../Widgets/MenuSuperior";
import CaixaFlutuanteInferior from "../Widgets/CaixaFlutuanteInferior";
import Swal from 'sweetalert2'
import Carousel from "../Widgets/Carousel";

export default {
  name: "Produto",
  data() {
    return {
      url: this.$store.state.url,
      adicional_ativo: false,
      prod: this.$store.state.produto,
      imagemAdicionalModal: "",
      imagens: this.$store.state.produto.galerias,
      item: {
        produto: {},
        adicionais: [],
        quantidade: (this.$store.state.produto.fracionado == 'S' && this.$store.state.produto.fator_qtde ? parseFloat(this.$store.state.produto.fator_qtde) : 1),
        observacao_cliente: ''
      },
      categoriaAdicionalQtd: [],
      categoriaAdicionalGrupos: [],
      categoriaAdicionalGruposObrigatorios: [],
      total_itens_adicionais: parseFloat(this.$store.state.produto.promocao == 'N' ? this.$store.state.produto.valor : this.$store.state.produto.valor_promocional).toFixed(2)
    }
  },
  components: {CaixaFlutuanteInferior, MenuSuperior, Bloco, TituloDestacado, Carousel},
  beforeMount() {
    var empresa_url = this.$router.currentRoute.params.empresa;
    this.$store.commit('empresaUrl', empresa_url);

    if (!this.$store.state.produto.nome) {
      this.$router.push('/' + this.$store.state.empresa_url);
      return;
    }

    this.$store.state.produto.adicionais.forEach(a => {
      a.produto_adicional_cat_id = 0;
      a.cat_nome = "Adicionais";
      a.quantidade = 1
    });
    this.$store.state.produto.categorias.forEach(c => {
      c.quantidade = 0;
      c.maiorValor = 0;
      c.adicionais.forEach(a => {
        a.quantidade = 0;
        a.obrigatorio = c.obrigatorio;
      });
    });


  },
  mounted() {
    $(window).scrollTop();

    $(document).ready(function () {
      $('.materialboxed').materialbox();
      $('.modal').modal();
    });

    if (this.$store.state.produto.nome == undefined) {
      this.$router.push('/' + this.$store.state.empresa_url);
    }

    if (this.$store.state.produto.adicionais) {
      this.$store.state.produto.adicionais.forEach(res => {
        if (res) {
          if (res.adicional != null) {
            this.adicional_ativo = true;
          }
        }
      });
    }

    if(this.$store.state.produto.controlar_estoque == 'S') {

        let total_produto_carrinho = 0;
        for (let i = 0; i < this.$store.state.pedido.itens.length; i++) {
          if (this.$store.state.pedido.itens[i].produto.id == this.prod.id)
            total_produto_carrinho = this.$store.state.pedido.itens[i].quantidade + total_produto_carrinho;
        }
        this.$store.state.produto.quantidade = this.$store.state.produto.quantidade - total_produto_carrinho;
    }

    },
  methods: {
    async compartilhar()
    {
      const currentUrl = window.location.href;
      const productId = currentUrl.split('/').pop();
      const newUrl = "/" + this.$store.state.empresa_url + "/menu?produto=" + productId;
      if (navigator.share)
      {
        this.compartilharComImagem(newUrl);
      } else {
        this.copiarParaAreaDeTransferencia(location.origin + newUrl);
      }
    },
    async compartilharComImagem(newUrl) {
      navigator.share({
        title: 'Compartilhar',
        text: this.prod.nome.toLocaleUpperCase(),
        url: newUrl
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.error('Error sharing:', error));
    },
    copiarParaAreaDeTransferencia(texto) {
      const el = document.createElement('textarea');
      el.value = texto;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      Swal.fire({
        icon: 'success',
        title: 'Link copiado!',
        text: 'Agora você já pode compartilhar este produto :)'
      });
    },
    selecionarImagem(link) {
      this.imagemAdicionalModal = link;
      this.$store.commit('imagem_zoom', this.imagemAdicionalModal)
    },
    adicionarItemDeCategorias(item, categoria) {
      const itemOriginal = item;
      localStorage.setItem('item', JSON.stringify(item));
      var item = item;
      var adicional = item.adicional;
      var qtd = this.categoriaAdicionalQtd[item.id];

      if (qtd == undefined) {
        qtd = 0
      }

      if (!qtd) {
        qtd = 0
      }

      var qtdGrupo = this.categoriaAdicionalGrupos[item.categoria.id];
      if (!qtdGrupo) {
        qtdGrupo = 0
      }

      if (item.limitar == 'S' && qtd >= item.maximo) {
        M.toast({html: 'Limite máximo atingido', displayLength: 3000})
        return;
      }

      if (item.categoria.limitar == 'S' && qtdGrupo >= item.categoria.maximo) {
        M.toast({html: 'Limite máximo atingido', displayLength: 3000})
        return;
      }

      qtd = qtd + 1;
      if (adicional.valor == '0.00') {
        adicional.valor = '0.00'
      }

      this.categoriaAdicionalQtd[item.id] = qtd;

      if (item.valor_adicional) {
        adicional.valor = item.valor_adicional;
      }

      var forSearch = [];
      forSearch.push(adicional);
      var itensp = this.item.adicionais.filter(itemLista => itemLista.id == adicional.id)
      //
      if (itensp != undefined) {
        if (itensp.length > 0) {

          adicional.quantidade = qtd;

          adicional.valor = parseFloat(qtd * adicional.valor).toFixed(2);
          var forDeletion = [];
          forDeletion.push(item.adicional);
          var itenspdel = this.item.adicionais.filter(itemDel => !forDeletion.includes(itemDel))
          this.item.adicionais = itenspdel;
        }
      }
      adicional.cat_nome = categoria.nome;
      this.item.adicionais.push(adicional)

      qtdGrupo = qtdGrupo + 1
      this.categoriaAdicionalGrupos[item.categoria.id] = qtdGrupo;

      if (itemOriginal.valor_adicional) {
        var or = JSON.parse(localStorage.getItem('item'))
        item.adicional.valor = or.valor_adicional;

        //item.adicional.valor = itemOriginal.valor_adicional;
        this.incrementarValorTotal(item.adicional.valor);
      } else {
        var or = JSON.parse(localStorage.getItem('item'))
        item.adicional.valor = or.adicional.valor;
        this.incrementarValorTotal(item.adicional.valor);
      }

    },
    removerItemDeCategorias(item) {
      if (qtd == undefined) {
        qtd = 0
      }

      var qtd = this.categoriaAdicionalQtd[item.id];
      if (!qtd) {
        qtd = 0
      }

      var qtdGrupo = this.categoriaAdicionalGrupos[item.categoria.id];
      if (!qtdGrupo) {
        qtdGrupo = 0
      }

      qtdGrupo = qtdGrupo - 1
      this.categoriaAdicionalGrupos[item.categoria.id] = qtdGrupo;

      qtd = qtd - 1;
      if (qtd < 0)
        return;

      this.categoriaAdicionalQtd[item.id] = qtd;

      var Index = this.item.adicionais.map(function (item) {
        return item.id;
      }).indexOf(item.adicional.id);

      this.item.adicionais[Index].quantidade = qtd;

      this.decrementarValorTotal(item.adicional.valor);

      if (this.item.adicionais[Index].quantidade == 0) {
        var forDeletion = [];
        forDeletion.push(this.item.adicionais[Index]);
        var itenspdel = this.item.adicionais.filter(itemDel => !forDeletion.includes(itemDel))
        this.item.adicionais = itenspdel;
      }

    },
    checarLimite(){
      if(this.$store.state.produto.controlar_estoque == 'S')
      {

          if(this.item.quantidade >= this.$store.state.produto.quantidade){
            M.toast({html: 'Limite máximo atingido',displayLength:3000})
            return false;
          }

        return true;
      }else{
        return true;
      }
    },
    atualizarQuantidade(valor) {
      var fator = 1;

      if (this.$store.state.produto.fracionado == 'S' && this.$store.state.produto.fator_qtde)
        fator = parseFloat(this.$store.state.produto.fator_qtde);


      if (valor) {
        if(this.checarLimite()){
          this.item.quantidade += fator
        }
      } else {
        if (this.item.quantidade > fator)
          this.item.quantidade -= fator;
      }
    },
    formatQtde() {
      return (this.$store.state.produto.fracionado == 'S' && this.$store.state.produto.fator_qtde ? this.item.quantidade.toFixed(3).replace('.', ',') : this.item.quantidade);
    },
    incrementarValorTotal(valor) {
      if (valor != '0.00') {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) + parseFloat(valor)).toFixed(2);
      } else {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) + parseFloat('0.01')).toFixed(2);
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) - parseFloat('0.01')).toFixed(2);
      }
    },
    decrementarValorTotal(valor) {
      if (valor != '0.00') {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) - parseFloat(valor)).toFixed(2);
      } else {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) - parseFloat('0.01')).toFixed(2);
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) + parseFloat('0.01')).toFixed(2);
      }
    },
    verificarCategorias() {
      var categorias = [];
      categorias = this.$store.state.produto.categorias;
      var resultado = true;
      categorias.forEach(res => {
        if (res.obrigatorio == 'S') {
          if (!this.categoriaAdicionalGrupos[res.id]) {
            resultado = false;
          }
          if (res.minimo) {
            if (this.categoriaAdicionalGrupos[res.id] && this.categoriaAdicionalGrupos[res.id] < res.minimo) {
              resultado = false;
            }
          }
        }
      });
      if (!resultado) {
        return false;
      }
      return true;
    },
    adicionarPedido() {
      this.item.produto.id = this.$store.state.produto.id;
      this.item.produto.valor = this.$store.state.produto.promocao == 'N' ? this.$store.state.produto.valor : this.$store.state.produto.valor_promocional;
      this.item.produto.nome = this.$store.state.produto.nome;
      this.item.produto.peso = this.$store.state.produto.peso;
      this.item.produto.promocao = this.$store.state.produto.promocao;

      console.log(JSON.parse(JSON.stringify(this.item)))
      this.$store.commit('adicionar_item_pedido', JSON.parse(JSON.stringify(this.item)))
      Swal.fire(
        'Atenção',
        'Produto inserido no carrinho com sucesso.',
        'success'
      ).then(res => {
        this.$router.back();
      }).catch(res => {
        this.$router.back();
      })
    },
    check: function (e, adi) {
      if (e.target.checked) {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) + parseFloat(adi.valor)).toFixed(2);
      } else {
        this.total_itens_adicionais = (parseFloat(this.total_itens_adicionais) - parseFloat(adi.valor)).toFixed(2);
      }
    }
  }
}
</script>

<!--<style scoped>-->
<!--h2 {-->
<!--  font-size: 3.56rem;-->
<!--  line-height: 110%;-->
<!--  margin: 0;-->
<!--}-->

<!--.itemb .titulo-descricao {-->
<!--  line-height: 2;-->
<!--  font-size: 0.90rem;-->
<!--  margin-bottom: 8px;-->
<!--}-->

<!--.bloco {-->
<!--  padding: 0px 10px;-->
<!--}-->

<!--.badge-promo {-->
<!--  width: 80px;-->
<!--  padding: 1px;-->
<!--  background-color: darkred;-->
<!--  color: white;-->
<!--  border-radius: 10px;-->
<!--}-->

<!--.notify-badge-slides{-->
<!--  position: absolute;-->
<!--  margin-left: 85%;-->
<!--  top: 70px;-->
<!--  width: 28px;-->
<!--  height: 28px;-->
<!--  color: #000000;-->
<!--  background: rgba(219, 219, 219, 0.45);-->
<!--  text-align: center;-->
<!--  border-radius: 50px;-->
<!--  padding: 5px 5px;-->
<!--  z-index: 9;-->
<!--  font-size: 12px;-->
<!--}-->

<!--</style>-->


<style scoped>
h2 {
  font-size: 3.56rem;
  line-height: 110%;
  margin: 0;
}

.bloco {
  padding: 0px 10px;
}

.btn-fechar {
  float: right;
  background-color: #ff00008a;
  font-weight: 900;
  margin: 10px;
}

.badge-promo {
  width: 80px;
  padding: 1px;
  background-color: darkred;
  color: white;
  border-radius: 10px;
}


@media only screen and (max-width: 450px) {
  .fotounica {
    max-height: 200px;
  }
}

@media only screen and (min-width: 450px) {
  .fotounica {
    max-height: 400px;
  }
}


.button-larges {
  text-decoration: none;
  display: inline-block;
  text-align: center;
  font-size: 10px;
  /*font-weight: bold;*/
  line-height: 15px;
  padding: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.itemb {
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  align-items: start;
}

.itemb .titulo-item {
  line-height: 2;
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.itemb .titulo-descricao {
  line-height: 2;
  font-size: 0.90rem;
  margin-bottom: 8px;
}

.itemb .titulo-valor {
  line-height: 2;
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.notify-badge-slides {
  position: absolute;
  margin-left: 85%;
  top: 70px;
  width: 28px;
  height: 28px;
  color: #000000;
  background: rgba(219, 219, 219, 0.45);
  text-align: center;
  border-radius: 50px;
  padding: 5px 5px;
  z-index: 9;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Produto.vue